// TelcoTrack — ACL směru osobní → neosobní (terénní „vratka“)
//
// Neosobní cíl = jen role sklad. Terénní role sem nesmí (jen osobní↔osobní převody).

import { hasWarehouseEditRole } from '../constants/roles.constants';
import {
  isPersonalWarehouse,
  type WarehouseUiGroupInput,
} from './warehouse-ui-group.util';
import type { WarehouseIssueActor } from './warehouse-issue-acl.util';
import { WAREHOUSE_TRANSFER_DENIED_FROM_BRANCH_CS } from './warehouse-transfer-acl.util';

export const WAREHOUSE_RETURN_DENIED_FROM_NOT_WORKER_CS =
  'Zdroj převodu musí být osobní sklad.';

export const WAREHOUSE_RETURN_DENIED_TO_NOT_BRANCH_CS =
  'Cíl převodu musí být neosobní sklad.';

export interface WarehouseReturnAccessResult {
  allowed: boolean;
  reasonCs: string | null;
}

/**
 * Osobní → neosobní: pouze role `sklad`.
 */
export function evaluateWarehouseReturnAccess(
  actor: WarehouseIssueActor,
  fromWarehouse: WarehouseUiGroupInput & { id: string },
  toWarehouse: WarehouseUiGroupInput & { id: string },
): WarehouseReturnAccessResult {
  const roles = actor.roles ? [...actor.roles] : [];

  if (!isPersonalWarehouse(fromWarehouse)) {
    return { allowed: false, reasonCs: WAREHOUSE_RETURN_DENIED_FROM_NOT_WORKER_CS };
  }
  if (isPersonalWarehouse(toWarehouse)) {
    return { allowed: false, reasonCs: WAREHOUSE_RETURN_DENIED_TO_NOT_BRANCH_CS };
  }

  if (!hasWarehouseEditRole(roles)) {
    return { allowed: false, reasonCs: WAREHOUSE_TRANSFER_DENIED_FROM_BRANCH_CS };
  }

  return { allowed: true, reasonCs: null };
}

export function canReturnStockToBranch(
  actor: WarehouseIssueActor,
  fromWarehouse: WarehouseUiGroupInput & { id: string },
  toWarehouse: WarehouseUiGroupInput & { id: string },
): boolean {
  return evaluateWarehouseReturnAccess(actor, fromWarehouse, toWarehouse).allowed;
}
